function toggleFilters() {
    const sidebar = document.querySelector('.VarCol-custom-sidebar-filters');
    sidebar.classList.toggle('active');
    document.body.classList.toggle('VarCol-no-scroll'); // Disable background scroll
}

document.addEventListener('click', function(event) {
    const sidebar = document.querySelector('.VarCol-custom-sidebar-filters');
    if (sidebar.classList.contains('active')) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = 'auto';
    }
});

function VarColApplyFilters() {
    // Get selected filters
    const sizeFilters = Array.from(document.querySelectorAll('.VarCol-filter-size:checked')).map(el => el.value);
    const fuelFilters = Array.from(document.querySelectorAll('.VarCol-filter-fuel:checked')).map(el => el.value);
    const finishFilters = Array.from(document.querySelectorAll('.VarCol-filter-finish:checked')).map(el => el.value);
    const typeFilters = Array.from(document.querySelectorAll('.VarCol-filter-type:checked')).map(el => el.value);

    document.querySelectorAll('.VarCol-variant-item').forEach(item => {
        const sku = item.getAttribute('data-sku');

        // Determine attributes from SKU
        const size = sku.match(/30|36|48/) ? sku.match(/30|36|48/)[0] : null;
        const fuel = sku.includes('GG') ? 'Gas/Gas' : sku.includes('GE') ? 'Gas/Electric' : null;
        const finish = sku.includes('BLACK') ? 'Black' : sku.includes('WHITE') ? 'White' : 'Stainless Steel';
        const type = sku.includes('PLSR') ? 'Freestanding Range' : sku.includes('PLST') ? 'Stove Top' : null;

        // Matching logic for each filter
        const matchesSize = !sizeFilters.length || sizeFilters.includes(size);
        const matchesFuel = !fuelFilters.length || fuelFilters.includes(fuel);
        const matchesFinish = !finishFilters.length || finishFilters.includes(finish);
        const matchesType = !typeFilters.length || typeFilters.includes(type);

        // Show or hide the item based on filter matches
        item.style.display = matchesSize && matchesFuel && matchesFinish && matchesType ? 'block' : 'none';
    });
}

// Add event listeners for filter inputs
document.querySelectorAll('.VarCol-filter-size, .VarCol-filter-fuel, .VarCol-filter-finish, .VarCol-filter-type').forEach(input => {
    input.addEventListener('change', VarColApplyFilters);
});

// Ensure checkbox is toggled when the label or surrounding area is clicked
document.querySelectorAll('.VarCol-filter-label').forEach(label => {
    label.addEventListener('click', (e) => {
        const checkbox = label.querySelector('input[type="checkbox"]');
        if (checkbox) {
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
        e.preventDefault();
    });
});

// Initial call to apply filters on page load
document.addEventListener('DOMContentLoaded', VarColApplyFilters);

document.querySelectorAll('.VarCol-accordion-button').forEach(button => {
    button.addEventListener('click', () => {
        button.classList.toggle('open');
        const content = button.nextElementSibling;
        content.style.display = content.style.display === 'block' ? 'none' : 'block';
    });
});

function VarColApplySort() {
    const sortBy = document.getElementById('VarCol-sort-by').value;
    const grid = document.getElementById('VarCol-variant-collection-product-grid');
    const items = Array.from(grid.getElementsByClassName('VarCol-variant-collection-item'));

    items.sort((a, b) => {
        const priceA = parseFloat(a.dataset.price);
        const priceB = parseFloat(b.dataset.price);
        return sortBy === 'price-low-to-high' ? priceA - priceB : priceB - priceA;
    });

    grid.innerHTML = '';
    items.forEach(item => grid.appendChild(item));
}
